import http from '@/services/BackendService'

const state = {
    current_page: 0,
    per_page: 0,
    total: 0,
    data: [],
    keyword: '',
    status: 'all',
    fromDate: '',
    toDate: '',
    summary: {
        total: 0,
        pending: 0,
        approved: 0,
        approved_not_paid: 0,
        rejected: 0,
        paid: 0,
        evidence_needed: 0,
        total_amount: '0.00',
        pending_amount: '0.00',
        approved_amount: '0.00',
        approved_not_paid_amount: '0.00',
        paid_amount: '0.00',
        evidence_needed_amount: '0.00',
        rejected_amount: '0.00',
    }
}

const getters = {
    getSummary: (state) => state.summary,
    getData: (state) => state.data,
    getFilters: (state) => ({
        keyword: state.keyword,
        status: state.status,
        fromDate: state.fromDate,
        toDate: state.toDate,
    }),
}

const mutations = {
    setData(state, data) {
        state.data = data.data
        state.current_page = data.current_page
        state.per_page = data.per_page
        state.total = data.total
    },
    setSummary(state, summary) {
        state.summary = summary
    },
    setKeyword(state, keyword) {
        state.keyword = keyword
    },
    setStatus(state, status) {
        state.status = status
    },
    setFromDate(state, fromDate) {
        state.fromDate = fromDate
    },
    setToDate(state, toDate) {
        state.toDate = toDate
    },
    resetFilters(state) {
        state.keyword = ''
        state.status = 'all'
        state.fromDate = ''
        state.toDate = ''
    },
}

const actions = {
    // Fetch summary statistics
    fetchSummary(context) {
        return new Promise((resolve, reject) => {
            http.get('floodReliefMission/admin/summary')
                .then((response) => {
                    context.commit('setSummary', response.data.data)
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    // Fetch all requests with pagination
    fetchRequests(context, payload = { page_number: 1 }) {
        return new Promise((resolve, reject) => {
            http.get(`floodReliefMission/admin/requests?page=${payload.page_number}`)
                .then((response) => {
                    context.commit('setData', response.data.data)
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    // Search and filter requests
    searchRequests(context, payload) {
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams()

            if (payload.page_number) {
                params.append('page', payload.page_number)
            }
            if (payload.keyword && payload.keyword !== '') {
                params.append('keyword', payload.keyword)
            }
            if (payload.status && payload.status !== '' && payload.status !== 'all') {
                params.append('status', payload.status)
            }
            if (payload.from_date && payload.from_date !== '') {
                params.append('from_date', payload.from_date)
            }
            if (payload.to_date && payload.to_date !== '') {
                params.append('to_date', payload.to_date)
            }

            http.get(`floodReliefMission/admin/requests/search?${params.toString()}`)
                .then((response) => {
                    context.commit('setData', response.data.data)
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    // Update filters
    updateKeyword(context, keyword) {
        context.commit('setKeyword', keyword)
    },
    updateStatus(context, status) {
        context.commit('setStatus', status)
    },
    updateFromDate(context, fromDate) {
        context.commit('setFromDate', fromDate)
    },
    updateToDate(context, toDate) {
        context.commit('setToDate', toDate)
    },
    resetFilters(context) {
        context.commit('resetFilters')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
